import React from 'react'
import Container from '../../Container/Container'
import Header from '../Header/Header'

function Care() {
  return (
    <Container>
      <div>
      <div>
        <Header/>
      </div>
      <h2>
        Plane Care
      </h2>
    </div>
    </Container>
  )
}

export default Care
